import { theme } from "../../theme.js";

export default function Card({ id, children, onClick  }) {
    const event_id = id || Math.random();
    const aria_labelledby = `event-${event_id}`|| "Add an event";
  return (
    <div key={event_id} style={styles.card} aria-labelledby={aria_labelledby} onClick={onClick}>
      {children}
    </div>
  );
}

const styles = {
card: {
    backgroundColor: theme.colors.bgDark,
    borderRadius: theme.radius.lg,
    overflow: "hidden",
    transition: theme.transitions.base,
    border: `1px solid ${theme.colors.border}`,
    display: "flex",
    flexDirection: "column",
    minHeight: "381px",
    height: "100%",
    cursor: "pointer",        
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "450px",
  },
};
